import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-row data-container" }
const _hoisted_2 = { class: "v-column" }
const _hoisted_3 = { class: "v-row data-statistic" }
const _hoisted_4 = { class: "statistic-item" }
const _hoisted_5 = { class: "statistic-item" }
const _hoisted_6 = { class: "statistic-item" }
const _hoisted_7 = { class: "statistic-item" }
const _hoisted_8 = {
  class: "v-row",
  style: {"--button-icon-size":"1.5em"}
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("播放全部")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("添加到")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = { class: "cell-text" }
const _hoisted_14 = ["data-mid"]
const _hoisted_15 = ["data-mid"]
const _hoisted_16 = { class: "name" }
const _hoisted_17 = ["data-mid"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" -")
const _hoisted_19 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_view = _resolveComponent("image-view")!
  const _component_hl_button = _resolveComponent("hl-button")!
  const _component_icon = _resolveComponent("icon")!
  const _component_table_view = _resolveComponent("table-view")!
  const _component_grid_view = _resolveComponent("grid-view")!
  const _component_tab_pane = _resolveComponent("tab-pane")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_image_view, {
        modelValue: _ctx.singer.cover,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.singer.cover) = $event)),
        defaultValue: "icon/singer.png"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(_ctx.singer.name || '-'), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, "单曲：" + _toDisplayString(_ctx.singer.songCount || '-'), 1),
          _createElementVNode("span", _hoisted_5, "专辑：" + _toDisplayString(_ctx.singer.albumCount || '-'), 1),
          _createElementVNode("span", _hoisted_6, "MV：" + _toDisplayString(_ctx.singer.mvCount || '-'), 1),
          _createElementVNode("span", _hoisted_7, "粉丝：" + _toDisplayString(_ctx.singer.fansCount || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_hl_button, { icon: "play-select" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_hl_button, { icon: "plus" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_hl_button, { icon: "my-download" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_hl_button, { icon: "trash" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_hl_button, {
            icon: "multiple",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.multiple = !_ctx.multiple))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.multiple ? '退出批量操作' : '批量操作'), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_tab_pane, {
      tabs: _ctx.tabs,
      activeTabName: _ctx.activeTabName,
      onTabChange: _ctx.handleTabChanged
    }, {
      song: _withCtx(() => [
        _createVNode(_component_table_view, {
          style: {"flex":"auto"},
          selection: _ctx.multiple,
          columns: _ctx.columns,
          data: _ctx.songList,
          onRowDblclick: _ctx.playMediaList,
          onInfiniteScroll: _ctx.loadDataList
        }, {
          title: _withCtx(({item}) => [
            _createElementVNode("span", _hoisted_13, _toDisplayString(item.title), 1),
            (item.vip)
              ? (_openBlock(), _createBlock(_component_icon, {
                  key: 0,
                  class: "vip-icon",
                  name: "vip",
                  width: "1em",
                  height: "1em"
                }))
              : _createCommentVNode("", true),
            (item.vid)
              ? (_openBlock(), _createBlock(_component_icon, {
                  key: 1,
                  class: "mv-icon",
                  name: "mv",
                  width: "1em",
                  height: "1em"
                }))
              : _createCommentVNode("", true)
          ]),
          singer: _withCtx(({item:{singer:singers = []}}) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singers, (singer, index) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "link cell-text",
                key: index,
                "data-mid": singer.mid
              }, _toDisplayString(singer.name), 9, _hoisted_14))
            }), 128))
          ]),
          album: _withCtx(({item:{album}}) => [
            album
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "link cell-text",
                  "data-mid": album.mid
                }, _toDisplayString(album.name), 9, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["selection", "columns", "data", "onRowDblclick", "onInfiniteScroll"])
      ]),
      album: _withCtx(() => [
        _createVNode(_component_grid_view, {
          "cell-widths": "repeat(auto-fit, 13em)",
          data: _ctx.albumList,
          onInfiniteScroll: _ctx.loadAlbumData,
          "cell-height": 234,
          onCellClick: _ctx.onAlbumItemClicked
        }, {
          default: _withCtx(({item}) => [
            _createVNode(_component_image_view, {
              modelValue: item.cover,
              "onUpdate:modelValue": ($event: any) => ((item.cover) = $event),
              defaultValue: "icon/album.png"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
          ]),
          _: 1
        }, 8, ["data", "onInfiniteScroll", "onCellClick"])
      ]),
      mv: _withCtx(() => [
        _createVNode(_component_grid_view, {
          class: "arc-rect",
          "cell-widths": "repeat(auto-fit, 16em)",
          data: _ctx.mvList,
          "cell-height": 206,
          onInfiniteScroll: _ctx.loadMvData
        }, {
          default: _withCtx(({item}) => [
            _createVNode(_component_image_view, {
              modelValue: item.cover,
              "onUpdate:modelValue": ($event: any) => ((item.cover) = $event),
              defaultValue: "icon/mv.png"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.singer, (singer, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "link",
                  key: index,
                  "data-mid": singer.mid
                }, _toDisplayString(singer.name), 9, _hoisted_17))
              }), 128)),
              _hoisted_18,
              _createElementVNode("span", null, _toDisplayString(item.title), 1)
            ])
          ]),
          _: 1
        }, 8, ["data", "onInfiniteScroll"])
      ]),
      introduce: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.singer.introduce), 1)
      ]),
      _: 1
    }, 8, ["tabs", "activeTabName", "onTabChange"])
  ], 64))
}